import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreForgeAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-forge-apps',
	path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?',
};
